module.exports = __webpack_public_path__ + "01_hair_black.6c7db00c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/01_hair_black.png
// module id = VUAC
// module chunks = 0